var glassesonInit = false;
var is_edge = navigator.userAgent.indexOf('Edge') > -1;
	var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
	var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
	var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
	var is_safari = navigator.userAgent.indexOf("Safari") > -1;
	var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
	if ((is_chrome)&&(is_safari)) {is_safari=false;}
	if ((is_chrome)&&(is_opera)) {is_chrome=false;}

	var isMobile = {
	    Android: function() {
	        return navigator.userAgent.match(/Android/i);
	    },
	    BlackBerry: function() {
	        return navigator.userAgent.match(/BlackBerry/i);
	    },
	    iOS: function() {
	        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	    },
	    Opera: function() {
	        return navigator.userAgent.match(/Opera Mini/i);
	    },
	    Windows: function() {
	        return navigator.userAgent.match(/IEMobile/i);
	    },
	    any: function() {
	        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
	    }
	};


if ( isValidPdBrowser() == true ) {
//if ( 1 == 1) {
	
	$('#ValidForMeasurement').css('display','block');
	
	glasseson = window.glasseson;
	server_url = 'https://www.glasseson.com/';
	
	var options = {
      	profileName:"web",
		flow: "pd",
		fullPage: true,
		width: 835,
		themeColor: "#5FB8E3" 
	};
	
	if (!glassesonInit) {
		
		glasseson.init(glasseson_client_id, server_url, options).then( 
			response => {
             // alert("success");
            
				handleSuccess(); 
			},
			error => { 
              alert("errorss");
				handleError(error);
			} 
		);
		
	}
	
	
} else {
	
	$('#ValidForMeasurement').css('display','none');
  $('.measure_pd_link').hide();
	$('#NotValidForMeasurement').css('display','block');
	
	if (glassesOnView == "rest") {
		alert("Sorry, your browser isn't compatible with our measurement tool.  Please contact customer service.");
	}
	
}


function handleError(error) {
	console.log(error);
   //alert("error");
   //alert(error);
}

function handleSuccess() {
	// alert("handleSuccess called");
	glassesonInit = true;
	
	glasseson.setResultCallback(resultCallback);
	
	if (glassesOnView == "rest") {
		glasseson.setCloseCallback(ajaxCloseCallback);
	} else {
		glasseson.setCloseCallback(standardCloseCallback);
	}
	
}

function resultCallback(result) {
	// overrides the display of the results
	// We'll display that on our own.
	//alert(" MR resultCallback called");
  //$("#contact__PD").text(result.data.pd);
  $("#pddata").val(result.data.pd);
   $('.pdsuccessmsg').show();
	//glasseson.close();
	
}

// for an ajax call - just display the results without a reload
function ajaxCloseCallback(result) {
  console.log(result);
  //alert(result);
	
	if ( result && result.data ) {
	//alert(result.data);
		console.log("Your PD is " + result.data.pd);
		console.log(result.data);
      $("#pddata").val(result.data.pd);
      $('.pdsuccessmsg').show();
		
		
		
		
		
	}
	
}

function hideSdk(){
  $('#glasseson.webapp.glasseson.go-fullpage').css('display','none');
}

// for the welcome page, reloads the page
function standardCloseCallback(result) {
	
  	//alert(result);
	if ( result && result.data ) {
	
		console.log("Your PD is " + result.data.pd);
      console.log(result.data);
      $("#pddata").val(result.data.pd);
      $('.pdsuccessmsg').addClass('show');
		
		
	
	}
	
}


function isValidPdBrowser () {
	
	if ( is_edge ) {
		return false;
	}
	
	if ( is_explorer ) {
		return false;
	}
	
	// browser support
	if ( isMobile.Android() ) {
		
		if ( is_chrome ) {
			return true;
		}
		
	}
		
	if ( isMobile.iOS() ) {
		
		if ( is_safari ) {
			return true;
		}
		
	}
	
	//desktop
	if ( !isMobile.any() ) {
		
		if ( is_safari ) {
			return true;
		}
		
		if (is_chrome) {
			return true;
		}
		
		if (is_firefox) {
			return true;
		}
		
	}
	
	return false;
	
}